import { WidgetCategory, type TrackGameClickParamsFromCategory } from '../types';

const getForegroundImageSrcSet = (url: string, width: number) => {
	// Image sizes for different DPRs
	const imageSizes = [width, width * 2, width * 3, width * 4];
	return imageSizes.map(size => `${url}?format=auto&width=${size} ${size}w`).join();
};

type WidgetData = WidgetCategory & {
	listName: string;
	trackGameClick: (props: TrackGameClickParamsFromCategory) => void;
};

export { getForegroundImageSrcSet, WidgetData };
